// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__F53m7","errorLogs":"EditorFooter_errorLogs__tCk-W"};